import { SupabaseClient } from '@supabase/supabase-js';

interface RecipeRecordWithImage {
  image?: string | null;
}

interface RecipeImageCleanupDependencies {
  extractFilePathFromImageUrl: (imageUrl: string) => string | null;
  triggerImageDelete: (filePath: string) => void | Promise<void>;
}

export const fetchRecipeImageForDeletion = async (
  supabaseClient: SupabaseClient,
  recipeId: string
): Promise<RecipeRecordWithImage | null> => {
  const { data, error } = await supabaseClient
    .from('recipes')
    .select('image')
    .eq('id', recipeId)
    .single();

  if (error) {
    console.error('Error fetching recipe image for deletion:', error);
    return null;
  }

  return (data as RecipeRecordWithImage | null) || null;
};

export const cleanupRecipeImage = (
  recipeToDelete: RecipeRecordWithImage | null,
  dependencies: RecipeImageCleanupDependencies
): void => {
  if (!recipeToDelete?.image) {
    return;
  }

  const filePath = dependencies.extractFilePathFromImageUrl(recipeToDelete.image);
  if (filePath) {
    dependencies.triggerImageDelete(filePath);
    return;
  }

  console.warn('Could not extract file path for image:', recipeToDelete.image);
};

export const deleteRecipeRecord = async (
  supabaseClient: SupabaseClient,
  recipeId: string
): Promise<void> => {
  const { error } = await supabaseClient.from('recipes').delete().eq('id', recipeId);

  if (error) {
    throw new Error(error.message);
  }
};
